import { createI18n } from "vue-i18n";
import ru from "./ru.json";
import en from "./en.json";
import kz from "./kz.json";
 
const i18n = createI18n({
  locale: localStorage.getItem('locale') || 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru,
    en,
    kz
  }
});

export default i18n;